var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.showModalOnboarding ? _c("modal-header") : _vm._e(),
      _vm.isOnboarding
        ? _c("onboarding", {
            attrs: {
              account: _vm.account.name,
              currentStep: _vm.onboardingStep,
            },
            on: { close: _vm.closeOnboarding },
          })
        : _vm._e(),
      _vm.isKycRouteEnabled
        ? _c("layout-kyc")
        : _vm.isSecretKeyOutdatedEnabled
        ? _c("layout-secret-key-outdated")
        : _c("layout-core"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }